<template>
  <div class="page h-100">
    <div class="container">
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/goods.html' }">选商品</el-breadcrumb-item>
          <el-breadcrumb-item>{{goodItem.styles}}|{{goodItem.name}} - 商品详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="main flex mb-30">
        <div class="left" v-if="goodItem.goodsPicList">
          <!-- <el-image :src="Utils.IMG_PREV + goodItem.goodsPicList[currentImgIndex].pic" fit="cover" class="pic mb-10"></el-image> -->
          <div class="pic">
            <pic-zoom :url="Utils.IMG_PREV + goodItem.goodsPicList[currentImgIndex].pic" :scale="2"></pic-zoom>
          </div>
          <div class="flex align-center w-100">
            <div class="list-btn" @click="toPrev"><i class="el-icon-arrow-left"></i></div>
            <div class="list mlr-10 flex-1 w-0">
              <div class="flex align-center picList" :style="{transform: 'translateX('+ (-moveWidth) +'px)'}">
                <div class="pic-item" :class="index === 0 ? '' : 'ml-10'" :style="{background:'url(' + Utils.IMG_PREV+item.pic + ') no-repeat center/cover'}" v-for="(item, index) in goodItem.goodsPicList" :key="index" @mouseenter="enter(index)">
                  <div class="w-100 h-100 flex align-center justify-center color-ff font-12" :class="currentImgIndex === index ? 'bg-c19357-5' : 'bg-00-5'"></div>
                </div>
              </div>
            </div>
            <div class="list-btn" @click="toNext"><i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
        <div class="right flex-1 w-0 flex-column align-end">
          <div class="flex-1 h-0 w-100">
            <div class="flex align-center mb-14">
              <div class="flex-1">
                <div class="font-12 color-292a2e mb-4">编码 {{goodItem.number}}</div>
                <div class="font-30 color-292a2e font-yahei mb-4">{{goodItem.styles}}|{{goodItem.name}}</div>
                <div class="font-12 color-94 mb-8"><span>生产周期:{{goodItem.productionCycle}}天</span><span class="ml-20">适用面积:{{goodItem.applicableArea}}㎡</span></div>
                <div class="font-12 color-94 mb-16">{{goodItem.profile}}</div>
                <div class="font-30 color-c19357 font-arial">¥{{Utils.toFixedNum(price)}}</div>
              </div>
              <div class="line"></div>
              <div class="h-100 flex-column justify-center align-center" @click="toBrandDetail()">
                <div class="brand mb-10">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="Utils.IMG_PREV + brandItem.photo"
                    fit="cover"></el-image>
                </div>
                <div class="font-12 color-292a2e">进入品牌店</div>
              </div>
            </div>
            <div class="hr-dashed mb-18"></div>
            <div class="flex mb-5" v-for="(item, index) in goodItem.goodsStandardList" :key="index">
              <span class="font-12 color-94 w-70 lh-30">{{item.name}}</span>
              <div class="flex-1 w-0 flex flex-wrap">
                <div v-for="(cellItem, cellIndex) in item.goodsAttributeList" :key="cellIndex" class="btn-30 plr-15 radius-round font-12 mr-5 mb-5" :class="attributeIndex[index] == cellIndex ? 'color-c19357 bg-f6efe6' : 'color-292a2e bg-eeeff3'" @click="chooseAttribute(index, cellItem, cellIndex)">
                  {{cellItem.value}}
                </div>
              </div>
            </div>
            <div class="flex mb-10">
              <span class="font-12 color-94 w-70 lh-30">个性化</span>
              <div class="flex-1 w-0">
                <el-input v-model="personalizedExplain"></el-input>
              </div>
            </div>
            <div class="flex mb-10">
              <span class="font-12 color-94 w-70 lh-30">个性化费用</span>
              <div class="w-170 ">
                <el-input v-model="personalizedPrice"></el-input>
              </div>
            </div>
            <div class="flex mb-10">
              <span class="font-12 color-94 w-70 lh-30">服务说明</span>
              <div class="flex-1 w-0 font-12 color-94 pt-8">
               {{goodItem.profile}}
              </div>
            </div>
          </div>
          <div class="flex align-center">
            <el-input-number v-model="goodItem.quantity" :min="1" class="mr-10"></el-input-number>
            <div class="btn-40 bg-292a2e color-ff w-172 radius-round font-yahei" @click="toSave">加入到我的方案</div>
          </div>
        </div>
      </div>
      <div class="recommend mb-30">
        <el-tabs v-model="activeName">
          <el-tab-pane label="设计搭配" name="first">
            <div class="p-30 flex align-center" v-if="goodItem.goodsCombinationList && goodItem.goodsCombinationList.length>0">
              <goods-recommend :goodItem="goodItem"></goods-recommend>
              <img src="/images/dapei.png" alt="" class="plr-30">
              <div class="line"></div>
              <div class="flex align-center flex-1 w-0">
                <div class="list-btn"><i class="el-icon-arrow-left"></i></div>
                <div class="list mlr-10 flex-1 w-0" v-if="goodItem.goodsCombinationList.length>0">
                  <div class="flex align-center justify-space-between">
                    <goods-recommend v-for="(item, index) in goodItem.goodsCombinationList" :goodItem="item.combinationGoods" :key="index" :index="index" :isChoose="1"></goods-recommend>
                  </div>
                </div>
                <div class="list-btn"><i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
            <div class="p-30 flex justify-end align-center bg-c19357-15">
              <div class="font-16 color-292a2e">已选<span class="color-ff5555">0</span>个配件，组合价：</div>
              <div class="font-30 color-c19357 font-arial mr-30">¥0.00</div>
              <div class="btn-40 bg-292a2e color-ff w-172 radius-round font-yahei" @click="toSave">加入到我的方案</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="同类推荐" name="second">
            <div class="p-30">
              <div class="flex align-center w-100">
                <div class="list-btn"><i class="el-icon-arrow-left"></i></div>
                <div class="list mlr-10 flex-1 w-0">
                  <div class="flex align-center" :class="SimilarGoodsList.length>5 ? 'justify-space-between' : ''">
                    <goods-recommend v-for="(item, index) in SimilarGoodsList" @classify-detail="classifyDetail(item.id)" :goodItem="item" :key="index" :index="index"></goods-recommend>
                  </div>
                </div>
                <div class="list-btn"><i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="对应套餐" name="third">
            <div class="p-30 flex align-center">
              <div class="cursor package-item mb-20" :class="index && index !== 0 ? 'ml-20' : ''" v-for="(item, index) in schemeList" :key="index" @click="toDetail(item.id)">
                <div class="pic">
                  <el-image :src="Utils.IMG_PREV+item.programmePicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
                </div>
                <div class="bottom flex align-center justify-space-between plr-30 ptb-26">
                  <div class="flex-1 mr-40 w-0">
                    <div class="font-16 color-292a2e font-yahei mb-6 text-overflow w-100">{{item.name}}</div>
                    <div class="flex align-center">
                      <span class="font-18 color-c19357 font-arial mr-10">¥{{Utils.toFixedNum(item.lowPrice)}}~{{Utils.toFixedNum(item.hightPrice)}}</span>
                    </div>
                  </div>
                  <img src="/images/jinruxiangqingbaibeijing.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="detail">
        <el-tabs v-model="activeName2">
          <el-tab-pane label="规格参数" name="four">
            <div class="p-30">
              <div class="bg-eeeff3-4 radius-4 p-30 mb-10">
                <div class="flex align-center mb-18">
                  <div class="title-line"></div>
                  <div class="font-16 font-yahei color-292a2e">基本信息</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">品牌</span>
                  <div class="flex-1 w-0">{{goodItem.brand || '-'}}</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">系列</span>
                  <div class="flex-1 w-0">{{goodItem.spaces || '-'}}</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">分类</span>
                  <div class="flex-1 w-0">{{goodItem.category || '-'}}</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">风格</span>
                  <div class="flex-1 w-0">{{goodItem.styles || '-'}}</div>
                </div>
              </div>
              <div class="bg-eeeff3-4 radius-4 p-30 mb-10">
                <div class="flex align-center mb-18">
                  <div class="title-line"></div>
                  <div class="font-16 font-yahei color-292a2e">规格属性</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8" v-for="(item, index) in goodItem.goodsStandardList" :key="index">
                  <span class="w-67">{{item.name}}</span>
                  <div class="flex-1 w-0 flex align-center">
                    <div v-for="(cellItem, cellIndex) in item.goodsAttributeList" :key="cellIndex">{{cellItem.value}}{{cellIndex+1 == item.goodsAttributeList.length ? '':'，'}}</div>
                  </div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">标签</span>
                  <div class="flex-1 w-0 flex align-center">
                    <div v-for="(cellItem, cellIndex) in goodItem.goodsTagList" :key="cellIndex">{{cellItem.name}}{{cellIndex+1 == goodItem.goodsTagList.length ? '':'，'}}</div>
                  </div>
                </div>
              </div>
              <!-- <div class="bg-eeeff3-4 radius-4 p-30">
                <div class="flex align-center mb-18">
                  <div class="title-line"></div>
                  <div class="font-16 font-yahei color-292a2e">其他信息</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">保养说明</span>
                  <div class="flex-1 w-0">避免阳光直射 避免潮湿 应放在通风处。</div>
                </div>
                <div class="flex align-center font-12 color-94 mb-8">
                  <span class="w-67">温馨提示</span>
                  <div class="flex-1 w-0">由于家具的特殊性 每个成品的尺寸、颜色会有些许差异 图片数据仅供参考 需以实物为准 敬请谅解！</div>
                </div>
              </div> -->
              <div class="hr-dashed mtb-30"></div>
              <div class="p-30" v-html="goodItem.description"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="商品详情" name="five">
            <div class="p-30 detailInfo" v-html="goodItem.description"></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <choose-scheme v-if="isChooseScheme" :currentGood="currentGood" @submit="OnSave"></choose-scheme>
    <div class="modal " v-if="isSaveSuccess" @scroll.stop.prevent @touchmove.prevent>
      <div class="content-save">
        <div class="flex justify-end p-10 mb-28">
          <img src="/images/guanbi.png" alt="" @click="onCloseSave" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/chenggong.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">保存成功</div>
          <div class="font-14 color-94 font-yahei">此方案已保存到我的方案中</div>
          <div class="font-14 color-94 font-yahei">请保持手机畅通，我们会及时联系您</div>
          <div class="font-14 color-94 font-yahei mb-60">并为您的方案提供更完善可行的调整设计！</div>
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round plr-30 font-yahei" @click="lookMyCase">查看我的方案</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsRecommend from '@/components/GoodsRecommend'
import ChooseScheme from '@/components/ChooseScheme'
import PicZoom from "vue-piczoom"

export default {
  name: 'GoodsDetail',
  components: {GoodsRecommend, ChooseScheme, PicZoom}, 
  computed: {},
  data () {
    return {
      value: '',
      num: 1,
      activeName: 'first',
      activeName2: 'four',
      moveWidth: 0,
      scrollWidth: 0,
      id: '',
      goodItem: {},
      currentImgIndex: 0,
      brandItem: {},
      page: 1,
      limit: 10,
      SimilarGoodsList: [],
      schemeList: [],
      price: 0,
      isChooseAttribute: false,
      attributeIndex: [],
      attributePrice: [],
      isChooseScheme: false,
      customerSpaceAttributeParamList:[],
      personalizedExplain: '',
      personalizedPrice: '',
      currentGood: {},
      isSaveSuccess: false,
    }
  },
  created () {
    this.id = this.$route.query.goodId.slice(0,-5)
    if (this.id) {
      this.getGoodItem()
      this.getScheme()
    }
  },
  mounted () {
  },
  methods: {
    getGoodItem () {
      this.axios.post(`goods/getById`, this.qs.stringify({id: this.id})).then(res => {
        if (res.data.success) {
          res.data.data.quantity = 1
          this.goodItem = res.data.data
          this.getBrand(res.data.data.brandId)
          this.getSimilarGood()
          this.scrollWidth = (this.goodItem.goodsPicList.length - 1) * 134 + 124
          for (let i in this.goodItem.goodsStandardList) {
            this.attributeIndex.push(-1)
            this.attributePrice.push(0)
          }

          this.goodItem.description = this.goodItem.description ? this.goodItem.description.replace(/<img/g,"<img style='width:100%;height:auto;'") : ''
          this.price = this.goodItem.isPeferential ? this.goodItem.preferentialPrice : this.goodItem.price
          this.originalPrice = this.goodItem.isPeferential ? this.goodItem.preferentialPrice : this.goodItem.price
        }
      })
    },
    getBrand (id) {
      this.axios.post(`brand/getById`, this.qs.stringify({id: id})).then(res => {
        if (res.data.success) {
          this.brandItem = res.data.data
        }
      })
    },
    getSimilarGood () {
      let params = {
        styleIds: this.goodItem.styleIds,
        limit: this.limit,
        page: this.page
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.SimilarGoodsList = res.data.data.list
        }
      })
    },
    chooseAttribute (index, cellItem, cellIndex) {
      this.isChooseAttribute = true
      this.$set(this.attributeIndex, index, cellIndex)
      this.$set(this.attributePrice, index, cellItem.priceRevision)
      this.$set(this.customerSpaceAttributeParamList, index, cellItem)
      let price = this.originalPrice
      for (let i of this.attributePrice) {
        price = price + i
      }
      this.price = price
    },
    toBrandDetail () {
      this.$router.push({path: '/brandDetail',query: {id: this.brandItem.id + '.html'}})
    },
    enter (index) {
      this.currentImgIndex = index
    },
    classifyDetail (id) {
      this.id = id
      this.getGoodItem()
      this.getScheme()
    },
    // 对应套餐
    getScheme () {
       this.axios.post(`programme/queryForPage`, {
        goodsId: this.id,
        limit: 10,
        page: 1
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          this.schemeList = list
        }
      })
    },
    toDetail (id) {
      this.$router.replace({name: 'SchemeDetail',query:{id: id + '.html'}})
    },
    toNext () {
      if (this.scrollWidth < 530) {
        return
      } else {
        if (this.moveWidth + 300 < this.scrollWidth - 530) {
          this.moveWidth += 300
        } else {
          this.moveWidth = this.scrollWidth - 530
        }
      }
    },
    toPrev () {
      if (this.moveWidth - 300 > 0) {
        this.moveWidth -= 300
      } else {
        this.moveWidth = 0
      }
    },
    toSave () {
      let flag = true
      for (let i of this.attributeIndex) {
        if (i == -1) {
          flag = false
          break
        }
      }
      if (flag) {
        if (this.$store.state.token) {
          this.isChooseScheme = true
          let item = this.goodItem
          item.goodsId = this.goodItem.id
          item.customerSpaceAttributeParamList = this.customerSpaceAttributeParamList
          item.personalizedExplain = this.personalizedExplain
          item.personalizedPrice = this.personalizedPrice
          this.currentGood = item
        } else {
          this.$store.dispatch('setLogin', true)
        }
      } else {
        this.$message({
          message: '请先选择商品属性',
          type: 'warning'
        })
      }
    },
    OnSave (e) {
      console.log(e)
      if (this.$store.state.token && this.$store.state.user) {
        this.axios.post(`customerSpaceGoods/save`, e).then(res => {
          if (res.data.success) {
            this.isSaveSuccess = true
            this.isChooseScheme = false
            this.getGoodItem()
          } else {
            this.$message({
              message: res.data.msg,
              type: "warn",
              offset: 400
            });
          }
        })
      } else {
        this.$message({
              message: '此操作需要先登录',
              type: "warn",
              offset: 400
            });
      }
    },
    lookMyCase () {
      this.isSaveSuccess = false
    },
    onCloseSave () {
      this.isSaveSuccess = false
    },
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .page{
    padding: 30px 0 120px;
    background: #eeeff3;
  }
  .main{
    background: #fff;
    border-radius: 4px;
    padding: 30px;
    box-shadow: 0px 30px 70px 0px	rgba(44, 51, 59, 0.07);
    .left{
      width: 610px;
      margin-right: 30px;
      .pic{
        height: 328px;
        width: 500px;
        border-radius: 4px;
        overflow: hidden;
      }
      .pic-item{
        width: 124px;
        height: 82px;
        border-radius: 4px;
        flex-shrink: 0;
        overflow: hidden;
        cursor: pointer;
      }
    }
    .right{
      .line{
        height: 140px;
        width: 1px;
        border-right: 1px dashed #e9e9e9;
        margin: 0 30px;
      }
      .brand{
        width: 86px;
        height: 86px;
        border-radius: 50%;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .recommend, .detail{
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px	rgba(44, 51, 59, 0.07);
  }
  .recommend{
    .line{
      height: 264px;
      width: 1px;
      background: #e9e9e9;
      margin-right: 30px;
    }
  }
  .package-item{
    width: 246px;
    flex-shrink: 0;
    box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
    .pic{
      height: 162px;
      width: 100%;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
    }
    .bottom{
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  

  .list-btn{
    cursor: pointer;
    background: #292a2e;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    i{
      color:#fff;
      font-size: 10px;
      font-weight: bold;
    }
    &:hover{
      background:  #c19357;
    }
  }
  .list{
    overflow: hidden;
  }
  .picList{
    transition-duration: 0.5s;
  }
  .w-67{
    display: inline-block;
    width: 67px;
  }
  .w-70{
    display: inline-block;
    width: 70px;
  }
  .w-170{
    width: 170px;
  }
  .w-172{
    width: 172px;
  }

  ::v-deep{
    .el-input__inner{
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
      border: solid 1px #e9e9e9;
      color: #292a2e;
      font-size: 12px;
    }
    .el-input-number .el-input__inner{
      padding: 0 50px;
    }
    .el-input-number{
      width: 150px;
      line-height: 40px;
      border-radius: 20px;
      overflow: hidden;
      .el-input__inner{
        font-size: 16px;
        height: 40px;
        border: 0;
        color: #292a2e;
        border: solid 1px #292a2e!important;
      }
    }
    .el-input-number__decrease, .el-input-number__increase{
      width: 50px;
      height: 40px;
      font-size: 16px;
      top: 0;
      border: 0;
      background: transparent;
      color: #292a2e;
      font-weight: bold;
    }
    .el-input-number__decrease{
      left: 0;
    }
    .el-input-number__increase{
      right: 0;
    }
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__nav-scroll{
      padding: 0 30px;
    }
    .el-tabs__item{
      height: 58px;
      line-height: 58px;
      font-size: 16px;
      font-family: '微软雅黑',sans serif;
    }
    .el-tabs__item.is-active, .el-tabs__item:hover{
      color: #c19357;
    }
    .el-tabs__nav-wrap::after{
      height: 1px;
      background: #e9e9e9;
    }
    .el-tabs__active-bar{
      background: #c19357;
      width: 32px!important;
      left: 16px
    }
  }
  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      height: 253px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
    .editGoods{
      width: 1105px;
      background: #ffffff;
      border-radius: 4px;
      .pic {
        width: 192px;
        height: 126px;
        border-radius: 4px;
        box-shadow: 0 30px 70px 0 rgba(44, 51, 59, 0.07);
        overflow: hidden;
      }
    }
    .delete {
      width: 394px;
      height: 405px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
</style>
